/** PRD / spec enums.model_tier */
export const AICOPY_MODEL_TIER_VALUES = new Set([
  "TRIAL",
  "FLEX",
  "LOCKED",
  "DEDICATED_NODE",
  "DEDICATED_DC",
]);

export function isValidAicopyModelTier(value) {
  if (value == null || value === "") return false;
  const normalized = String(value).trim().toUpperCase().replace(/[\s-]+/g, "_");
  return AICOPY_MODEL_TIER_VALUES.has(normalized);
}

/** 出队前清洗单条事件 */
export function sanitizeAicopyBehaviorEvent(event) {
  if (!event || event.event_name !== "aicopy_model_select") return event;
  const tier = event.properties?.model_tier;
  if (tier == null || isValidAicopyModelTier(tier)) return event;
  return null;
}
